<div class="container">
  @if (coaSummaryProcessed){
  <div class="section">
    <div class="header"><h2>Records Processed in Initial Run</h2></div>
    <div class="row">
      <div class="box">
        <div class="number">
          {{ coaSummaryProcessed.total_records_from_tb || 0 }}
        </div>
        <div class="label">Total records from Trial Balance</div>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="header"><h2>Chart of Account Mapping</h2></div>
    <div class="row">
      <div class="box">
        <div class="number">
          {{ coaSummaryProcessed.number_rows_mapped || 0 }}
        </div>
        <div class="label">Mapped</div>
      </div>
      <div class="box">
        <div class="number">
          {{ coaSummaryProcessed.number_rows_not_mapped || 0 }}
        </div>
        <div class="label">
          Unmapped
          <motif-tooltip>
            <motif-tooltip-trigger>
              <motif-icon
                class="info-icon"
                size="20"
                [iconFunction]="IconoirInfoCircle"
                [tabIndex]="0"
                aria-live="polite"
              ></motif-icon>
            </motif-tooltip-trigger>
            <motif-tooltip-content placement="auto">
              <div class="tooltip">
                <p class="preserve-linebreaks">
                  {{ formatTooltipContent(hoverableInfo) }}
                </p>
              </div>
              <motif-tooltip-arrow></motif-tooltip-arrow>
            </motif-tooltip-content>
          </motif-tooltip>
        </div>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="header"><h2>Unmapped records</h2></div>
    <div class="row">
      <div class="box padding-left-0">
        <ul class="list">
          <li>
            <motif-icon
              style="float: left;"
              class="list-icon"
              size="20"
              fill="#4d4d5c"
              [iconFunction]="IconoirNavArrowRight"
            ></motif-icon>

            {{ coaSummaryProcessed.unmapped_missing_account_code_from_coa }}

            @if(coaSummaryProcessed.unmapped_missing_account_code_from_coa ==
            1){
            <span
              >corresponding account code is not present in the latest Chart of
              Accounts</span
            >
            }@else{
            <span
              >corresponding account codes are not present in the latest Chart
              of Accounts</span
            >
            }
          </li>

          <li>
            <motif-icon
              style="padding: 0px; float:left;"
              class="list-icon"
              size="20"
              fill="#4d4d5c"
              [iconFunction]="IconoirNavArrowRight"
            ></motif-icon>

            {{ coaSummaryProcessed.unmapped_ai_fail }}

            @if(coaSummaryProcessed.unmapped_ai_fail == 1){
            <span>AI failure</span>
            }@else{
            <span>AI failures</span>
            }
          </li>
        </ul>
      </div>
    </div>
  </div>
  }
</div>
